import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appointableQueryKeys } from "./appointableQueryKeys";

export const useMutationDeleteAppointable = ({ api }: { api: ApiType }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (appointableId: number) =>
      await api.appointableApi.delete(appointableId),
    onSuccess: async () =>
      await queryClient.invalidateQueries({
        queryKey: appointableQueryKeys.all(),
      }),
  });
};
